// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");

function NewPasswordInput(props) {
  var __containerClassName = props.containerClassName;
  var __labelClassName = props.labelClassName;
  var __passwordInputClassName = props.passwordInputClassName;
  var passwordInputClassName = __passwordInputClassName !== undefined ? __passwordInputClassName : "border border-gray-500 hover:border-gray-700 focus:border-teal-500 outline-none w-400-px px-20-px py-10-px";
  var labelClassName = __labelClassName !== undefined ? __labelClassName : "font-semibold mb-10-px";
  var containerClassName = __containerClassName !== undefined ? __containerClassName : "";
  return JsxRuntime.jsx("label", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: props.label,
                            className: labelClassName
                          }),
                      JsxRuntime.jsx("input", {
                            className: passwordInputClassName,
                            autoComplete: "new-password",
                            type: "password",
                            value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Password.show, props.password),
                            onChange: props.handleChange
                          })
                    ],
                    className: containerClassName
                  }),
              className: "block mb-10-px"
            });
}

var make = NewPasswordInput;

exports.make = make;
/* react/jsx-runtime Not a pure module */
